"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
var _replaceStringVars = _interopRequireDefault(require("../string/replaceStringVars"));
var _defaultStaticContent = _interopRequireDefault(require("./defaultStaticContent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Singleton for managing access to a static content object
 * set(source) : Content object can be set from @source object
 * get(key, vars) : Returns a value based on @key and optional @vars.
 * @key = 'aKey'
 * @vars = { varPlaceholderName: 'valueToReplacePlaceholderWith'}
 * If @key value is FALSEY the key is returned
 * If @key value is a string and @vars object is provided, the string is processed with replaceStringVars
 */
var StaticContent = /*#__PURE__*/function () {
  function StaticContent() {
    _classCallCheck(this, StaticContent);
    this.content = _defaultStaticContent["default"];
  }
  _createClass(StaticContent, [{
    key: "set",
    value: function set() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // console.warn('StaticContent set:', source);

      if (!(0, _isPlainObject["default"])(source)) {
        console.error('Expected object with key value pairs'); // eslint-disable-line no-console
        return;
      }
      this.content = Object.assign({}, _defaultStaticContent["default"], source);
    }
  }, {
    key: "get",
    value: function get(key, vars) {
      var hasVars = (0, _isPlainObject["default"])(vars);

      // if no value use the key
      var content = this.content[key];
      if (content && (0, _isString["default"])(content)) {
        // replace any string vars if supplied
        return hasVars ? (0, _replaceStringVars["default"])(content, vars) : content;
      }
      throw new Error("Static Content key cannot be found: ".concat(key));
    }
  }, {
    key: "add",
    value: function add() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.content = Object.assign(this.content, source);
    }
  }, {
    key: "getContent",
    value: function getContent() {
      return this.content;
    }
  }]);
  return StaticContent;
}();
var _default = exports["default"] = new StaticContent();